// src/components/PrivateRoute/PrivateRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { isLoggedIn, loading } = useAuth();
  const location = useLocation();

  // Pendant le chargement initial (vérif localStorage), on affiche un spinner
  if (loading) {
    return <div style={{ paddingTop: 'var(--navbar-h)' }}><div className="spinner" /></div>;
  }

  // Si non connecté → redirection vers login avec mémorisation de l'URL voulue
  if (!isLoggedIn) {
    return <Navigate to="/connexion" state={{ from: location }} replace />;
  }

  return children;
}